import AsyncSelectLoadMore from './AsyncSelectLoadMore';

export default AsyncSelectLoadMore;
